import { writable, get } from 'svelte/store';
import { tick } from 'svelte';

export const PaywallJSState = writable({
	shouldLoad: false
})

export const addPaywallJS = async () => {
	await tick()
	PaywallJSState.set({shouldLoad: true})
}